// @flow
import { windowStates } from 'catena/er2_map_userlayers/js/components/window_state'
import type { WindowStateType } from 'catena/er2_map_userlayers/js/components/window_state'
import * as actionTypes from '../constants/action_types'

export type ZoneType = '' | 'Electricity' | 'Fuel' | 'Transportation' | 'Water'

export type TransimsType = {
    visible: boolean,
    running: boolean,
    // Catena raster layer type
    template_raster: {},
    windowState: WindowStateType,
    zoneColors: { [ZoneType]: string }
}

const initialState = {
    visible: true,
    running: false,
    windowState: windowStates.opened,
    zoneColors: {
        Electricity: 'rgb(0, 255, 0)',
        Fuel: 'rgb(255, 0, 0)',
        Transportation: 'rgb(0, 0, 0)',
        Water: 'rgb(0, 0, 255)',
    },
}

export default function transims(state: TransimsType = initialState, action) {
    let newstate = state
    if (action.type === actionTypes.SET_FETCHED_STATE) {
        if (action.state.appState && action.state.appState.transims) {
            newstate = { ...state, ...action.state.appState.transims, running: false }
        }
    } else if (action.type === actionTypes.TRANSIMS_RUNNING) {
        newstate = { ...state, running: action.running }
    } else if (action.type === actionTypes.TRANSIMS_ZONE_COLOR) {
        // Convert hex to rgb
        const r = parseInt(action.color.substring(1, 3), 16)
        const g = parseInt(action.color.substring(3, 5), 16)
        const b = parseInt(action.color.substring(5, 7), 16)
        newstate = { ...state, zoneColors: { ...state.zoneColors, [action.zone]: `rgb(${r}, ${g}, ${b})` } }
    }
    return newstate
}
